
import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

interface ImageUrlComponentProps {
  value: string;
  onChange: (url: string | undefined) => void;
}

const ImageUrlComponent: React.FC<ImageUrlComponentProps> = ({ value, onChange }) => {


  return (
    <FormControl variant="outlined" sx={{ mt: 0 }}>
      <Box sx={{
        position: 'relative',
        border: '1.5px solid #bdbdbd',
        borderRadius: 2,
        p: 2,
        pt: 3,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 2,
      }}>
        <FormLabel
          component="legend"
          sx={{
            position: 'absolute',
            top: 0,
            left: 12,
            transform: 'translateY(-50%)',
            bgcolor: '#ffffff',
            px: 0.5,
            fontSize: 13,
            color: 'text.secondary',
            zIndex: 1,
          }}
        >
          Thumbnail
        </FormLabel>
        <Box sx={{
          width: 120,
          height: 120,
          border: '1px solid #e0e0e0',
          borderRadius: 2,
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          {value ? (
            <img src={value} alt="Thumbnail" style={{ maxWidth: '100%', maxHeight: '100%' }} />
          ) : (
            <img src="https://via.placeholder.com/120?text=No+Image" alt="No Thumbnail" style={{ maxWidth: '100%', maxHeight: '100%', opacity: 0.5 }} />
          )}
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 0.5, width: '78%' }}>
          <FormLabel sx={{ mb: 1, fontSize: 13, color: 'text.secondary' }}>Paste Image URL</FormLabel>
          <input
            type="text"
            value={value || ''}
            onChange={e => onChange(e.target.value)}
            placeholder="https://..."
            style={{ width: '100%', padding: '8px', fontSize: '15px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: 8 }}
          />
          {value && (
            <Button
              variant="outlined"
              color="error"
              sx={{ mt: 1, width: 120 }}
              onClick={() => onChange(undefined)}
            >
              Clear
            </Button>
          )}
        </Box>
      </Box>
    </FormControl>
  );
};

export default ImageUrlComponent;
